import React from "react";
import { Link, useLocation } from "react-router-dom";
import SearchResult from './SearchResult';

function LinkSearchResult({ data, highlight }) {
  const location = useLocation();

  const query = Object.fromQueryString( location.search );

  query.display = `${ data.unitid }-${ data.cipCode}-${ data.degreeLevel }`

  const url = `/scorecard/${ data.unitid }/${ data.cipCode}/${ data.degreeLevel }`;

  return (
    <Link to={{ pathname: url, search: location.search }} className="result-link">
      <SearchResult searchResult={ data } highlight={ highlight }/>
    </Link>
  );
}

export default LinkSearchResult;
